import { useState, useEffect } from 'react';
import { loadAssistants } from '@config/assistants.config';
import { Assistant } from '@/types';

interface UseAssistantsReturn {
    assistants: Record<string, Assistant>;
    loading: boolean;
    error: Error | null;
}

/**
 * Custom hook to load and manage assistants
 */
export const useAssistants = (): UseAssistantsReturn => {
    const [assistants, setAssistants] = useState<Record<string, Assistant>>({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchAssistants = async () => {
            try {
                setLoading(true);
                const loadedAssistants = await loadAssistants();
                setAssistants(loadedAssistants);
                setError(null);
            } catch (err) {
                console.error('Failed to load assistants:', err);
                setError(err as Error);
            } finally {
                setLoading(false);
            }
        };

        fetchAssistants();
    }, []);

    return { assistants, loading, error };
};